"use client";

import { useEffect, useRef, useState } from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Alyssa",
  quote: "\"I would choose D&J 1000 times over. These guys are experts and so fun!\"",
  position: "Happy Bride"
}, {
  id: 2,
  author: "Molly",
  quote: "\"Damion and Joe are absolutely top-notch! They brought so many fun ideas and helpful suggestions for our wedding day\"",
  position: "Happy Bride"
}, {
  id: 3,
  author: "Tara S.",
  quote: "\"Not only did they keep us on schedule, they brough an amazing vibe and kept the party going all night long\"",
  position: "Happy Mother of the Bride"
}];
export default function WhatOurClientsSay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [isPaused, setIsPaused] = useState(false);
  const [api, setApi] = useState<any>(null);
  const autoPlayRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (!api || isPaused) {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
        autoPlayRef.current = null;
      }
      return;
    }
    autoPlayRef.current = setInterval(() => {
      api.scrollNext();
    }, 4000);
    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [api, isPaused]);
  return <section ref={ref} className="relative bg-dark-background py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {}
      <div className="absolute top-10 left-10 w-24 h-24 bg-accent/20 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-primary/20 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/4 w-16 h-16 border-4 border-secondary/30 rotate-45" />

      <div className="max-w-7xl mx-auto">
        {}
        <h2 className={`text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-center mb-4 text-foreground-dark transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
        transitionDelay: "100ms"
      }}>
          What Our Clients Say
        </h2>

        <p className={`text-lg text-center text-muted mb-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
        transitionDelay: "200ms"
      }}>
          Real feedback from real people who partied with us!
        </p>

        {}
        <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
          <Carousel opts={{
          align: "center",
          loop: true,
          skipSnaps: false,
          dragFree: false
        }} setApi={setApi} className="w-full max-w-5xl mx-auto">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className={`h-full bg-muted-dark-background border-2 border-primary/30 hover:border-secondary hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`} style={{
                transitionDelay: `${300 + i * 100}ms`
              }}>
                    <CardContent className="p-6 flex flex-col h-full">
                      {}
                      <div className={`mb-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}`} style={{
                    transitionDelay: `${400 + i * 100}ms`
                  }}>
                        <Quote className="w-12 h-12 text-white" />
                      </div>

                      {}
                      <blockquote className={`text-foreground-muted-dark text-base sm:text-lg mb-6 flex-grow transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
                    transitionDelay: `${500 + i * 100}ms`
                  }}>
                        "{testimonial.quote}"
                      </blockquote>

                      {}
                      <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
                    transitionDelay: `${600 + i * 100}ms`
                  }}>
                        <div className="font-display font-semibold text-foreground-dark text-lg">
                          {testimonial.author}
                        </div>
                        <div className="text-muted text-sm">
                          {testimonial.position}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>

            <CarouselPrevious className="hidden sm:flex bg-primary text-foreground-primary hover:bg-primary-hover border-primary" />
            <CarouselNext className="hidden sm:flex bg-primary text-foreground-primary hover:bg-primary-hover border-primary" />
          </Carousel>
        </div>
      </div>
    </section>;
}